// export DsfDepartmentMigration from "./departmentMigration.vue";

export const DsfDepartmentMigration =dsf.defineAsyncComponent('DsfDepartmentMigration',()=>import(/*webpackChunkName:"platform_pc_other"*/"./departmentMigration.vue"))